import { Rating } from "primereact/rating";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import Flag from "react-world-flags";
import { modifyMediaUrl } from "../../helpers/modifyMediaUrl";
import { getLanguageDisplayName } from "../../helpers/languageHelper";
import { LANGUAGE_PROFICIENCY } from "../../constants/language-proficiency";
import formatRating from "../../helpers/formatRating";

const TrainerDetailProfile = ({
  trainer = {},
  defaultAvatar,
  labels,
  translations
}) => {
  const getLanguageName = (locale) => {
    if (typeof locale !== "string" || !locale.includes("-")) {
      return null;
    }
    const languageCode = locale.split("-")[0].toLowerCase();
    return getLanguageDisplayName(languageCode);
  };

  const getCountryCodeFromLanguage = (locale) => {
    if (typeof locale !== "string" || !locale.includes("-")) {
      return null;
    }
    return locale.split("-")[1].toUpperCase();
  };

  const localizedLevels = (langLevel) => {
    let label = "";
    let tagClass = "";
    switch (langLevel) {
      case LANGUAGE_PROFICIENCY.BEGINNER:
        label = translations.levelBeginner;
        tagClass = "beginner-tag";
        break;
      case LANGUAGE_PROFICIENCY.ELEMENTARY:
        label = translations.levelElementary;
        tagClass = "elementary-tag";
        break;
      case LANGUAGE_PROFICIENCY.INTERMEDIATE:
        label = translations.levelIntermediate;
        tagClass = "intermediate-tag";
        break;
      case LANGUAGE_PROFICIENCY.UPPER_INTERMEDIATE:
        label = translations.levelUpperIntermediate;
        tagClass = "upper-intermediate-tag";
        break;
      case LANGUAGE_PROFICIENCY.ADVANCED:
        label = translations.levelAdvanced;
        tagClass = "advanced-tag";
        break;
      case LANGUAGE_PROFICIENCY.NATIVE:
        label = translations.levelNative;
        tagClass = "native-tag";
        break;
      default:
        break;
    }
    return { label, tagClass };
  };

  return (
    <div className="flex gap-4">
      <div className="tutor-avatar-container flex justify-content-center align-items-center">
        <img src={trainer.avatar ? modifyMediaUrl(trainer.avatar) : defaultAvatar} alt="" className="object-fit-cover"/>
      </div>
      <div className="flex flex-column gap-3">
        <div className="flex gap-2">
          <div className="keduall-typography heading-h5-semibold-600">{trainer.nickName || trainer.displayName}</div>
          <Flag code={trainer.nationality} className="tutor-flag object-fit-cover" />
          <div
            className="tutor-favorite keduall-typography text-danger-txt" 
          >
            <i
              className="pi pi-heart-fill"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <Rating className="keduall-rate rate-medium" value={trainer.averageRating} readOnly cancel={false} />
          <div>({formatRating(trainer.averageRating)})</div>
        </div>
        <div>
          {trainer.languages && trainer.languages.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {trainer.languages.map((language, index) => (
                <div className="flex gap-1 align-items-center" key={index}>
                  <div className={`flag-container ${language.languageCode}-flag`}
                    data-pr-tooltip={getLanguageName(language.languageCode)}
                    data-pr-position="bottom"
                  >
                    <Flag code={getCountryCodeFromLanguage(language.languageCode)}
                      className="w-full h-full object-fit-cover"
                    />
                  </div>
                  <Tag value={translations[`LANGUAGE_PROFICIENCY_${language.proficiencyCode}`]} className={`keduall-tag ${localizedLevels(language.proficiencyCode).tagClass} keduall-typography text-14-medium-500`} />
                  {index !== trainer.languages.length - 1 && <span>,</span>}
                  <Tooltip target={`.${language.languageCode}-flag`} className="tag-tooltip"/>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="flex gap-2 flex-wrap">
          {trainer.tagList && trainer.tagList.map((tag, index) => (
            <Button
              label={translations[tag]}
              className="keduall-buttons button-filled-default-small-primary keduall-typography text-14-semibold-600 cursor-auto"
              onClick={() => {}}
              key={index}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default TrainerDetailProfile;